module.exports = __webpack_public_path__ + "img/attach_file.04696a9f.svg";